// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a99877580be49283e6602ecc0cf76c0b28e7455b.chunk.js";
};